import { useRef } from "react";

function QuickConnect() {

    const formRef = useRef(null);

    function toggleForm() {
        if (formRef.current.className === "quick-connect-form") {
            formRef.current.className = "quick-connect-form quick-connect-form-show";
        }
        else {
            formRef.current.className = "quick-connect-form";
        }
    }

    function handleSubmit(event) {
        event.preventDefault();
        // Handle form submission logic here
    }

    return (
        <div className="quick-connect-container">
            <div className="quick-connect" onClick={toggleForm}>
                <span className='quick-connect-text'>Connect With Us</span>
            </div>
            <form ref={formRef} className="quick-connect-form" onSubmit={handleSubmit}>
                <div className="quick-connect-form-group">
                    <input id="full-name" type="text" className="quick-connect-form-control-input" placeholder="Full Name" />
                </div>
                <div className="quick-connect-form-group">
                    <input id="email" type="email" className="quick-connect-form-control-input" placeholder="Email" />
                </div>
                <div className="quick-connect-form-group">
                    <input id="phone" type="tel" className="quick-connect-form-control-input" placeholder="Phone" />
                </div>
                <div className="quick-connect-form-group">
                    <textarea id="message" className="quick-connect-form-control-textarea" placeholder="Message" />
                </div>
                <div className="quick-connect-form-group">
                    <input id="submit" type="submit" className="quick-connect-form-control-btn" value="Submit" />
                </div>
            </form>
        </div>
    );
}

export default QuickConnect;
